import * as React from 'react';
import Container from "react-bootstrap/Container";
import NavbarComponent from './fields/NavbarComponent';
import TableComponent from './fields/TableComponent';
import { Route, Switch, NavLink } from 'react-router-dom';
import ModulesNavbarComponent from './modules/NavbarComponent';
import ModulesTableComponent from './modules/TableComponent';
import FieldsMain from './fields/FieldsMain';
import ModulesMain from './modules/ModulesMain';

interface MainState {
    tableSearch: string, fieldSearch: string, wholeWords: boolean;
}

export default class Main extends React.Component<{}, MainState>
{

    constructor(props: {}) {
        super(props);

        this.state = {tableSearch: "", fieldSearch: "", wholeWords: false};
        this.onSearchChange = this.onSearchChange.bind(this);
    }

    private onSearchChange(tableSearch: string, fieldSearch: string, wholeWords: boolean) {
        this.setState({tableSearch: tableSearch, fieldSearch: fieldSearch, wholeWords: wholeWords});
    }

    public render(): JSX.Element
    {
        return (
            <>
                <Switch>
                    <Route exact path="/">
                        <FieldsMain />
                    </Route>
                    <Route exact path="/modules">
                        <ModulesMain />
                    </Route>
                    <Route path="*">
                        <div>Nenalezeno.</div>
                    </Route>
                </Switch>
            </>
        );
    }
}

export const NavbarLinks = () => <>
    <NavLink to="/" exact className="nav-link" activeClassName="active">Databáze</NavLink>
    <NavLink to="/modules" className="nav-link" activeClassName="active">Moduly</NavLink>
</>;